import React, { useRef, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useColourMode } from "../contexts/ColourContext";

const SubMenu = ({ menuOptions }) => {
  const location = useLocation();
  const { accentColour } = useColourMode();
  const colourTheme = useTheme();

  const scrollRef = useRef(null);

  useEffect(() => {
    // Retrieve saved scroll position from session storage
    const savedScrollPosition = sessionStorage.getItem("scrollPosition");

    if (savedScrollPosition && scrollRef.current) {
      scrollRef.current.scrollLeft = parseInt(savedScrollPosition, 10);
    }

    // Save the current scroll position whenever it changes
    const handleScroll = () => {
      if (scrollRef.current) {
        sessionStorage.setItem("scrollPosition", scrollRef.current.scrollLeft);
      }
    };

    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Clean up scroll event listener
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [location.pathname]); // Trigger whenever the route changes

  return (
    <Box
      ref={scrollRef}
      sx={{
        display: "flex",
        flexDirection: "row",
        overflowX: "auto", // Enable horizontal scrolling
        overflowY: "hidden", // Prevent vertical overflow
        WebkitOverflowScrolling: "touch", // Smooth scrolling on mobile devices
        "::-webkit-scrollbar": {
          display: "none", // Hide scrollbar for Webkit browsers
        },
        msOverflowStyle: "none", // Hide scrollbar for IE and Edge
        scrollbarWidth: "none", // Hide scrollbar for Firefox
      }}
    >
      {menuOptions.map((item, index) => {
        const isActive = location.pathname === item.path;

        return (
          <Box
            key={index}
            component={Link}
            to={item.path}
            sx={{
              color: isActive ? accentColour : colourTheme.palette.text.primary,
              backdropFilter: "blur(1rem)",
              boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
              fontSize: "0.9rem",
              border: `1px solid ${colourTheme.palette.text.primary}`,
              borderRadius: "1rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "fit-content",
              padding: "0.25rem 0.5rem",
              textDecoration: "none",
              marginRight: "0.75rem",
              whiteSpace: "nowrap",
            }}
          >
            {item.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default SubMenu;
